<template lang="pug">
div(:class="$style.talkswrapper")
  .c-the-home-chairmantalk
    chairman-box(:photo="chairmanPhoto"
      name="葉進華"
      job="第十六屆理事長"
      homeland="高樹")
    .content.has-text-weight-medium.app-text
      p 日行千里 始於足下
        br
        br
        | 滾動的日子，時間呼嘯而過，二年的任期轉眼即屆，心中有無限的感恩，因為有您，做您能做，幫您能幫，我們才能在穩定中持續經營會務。
        br
        br
        | 回顧二年來，由於中美貿易戰，新冠病毒疫情的影響，全球經濟都呈負成長，失業人口不斷增加，國民收入遽減，相對的民間社團運作也面臨困境。而本會尤其可貴，全員上下一心，一切按年度計劃正常實施，除了守住傳統例行活動，做好會員服務與維繫會員互動外，並積極推動全面行政電腦化作業，2000多位會員資料已建完成，線上繳費、繳費紀錄查詢、ATM轉帳、電子收據……等無紙化作業已具成效，去年會員大會，以六部手提電腦、二部列表機，同時收費、列印收據，快速又正確，而活動照片、會議文件都完全登入，凡走過必留足跡，為效率提升一步到位。這期間，不是瞬間達成的，而是多少人拼手胝足，一步步走出來的。
        br
        br
        | 在大家的期盼下，本會會館於誕生了，會館每個角落，盡是溫馨且有趣的布置，也是鄉親們愛心慷慨的集合體，電視、冰箱、辦公桌、儲櫃、椅子、沙發、洗手台、屏風、茶、茶具、茶桌、咖啡、咖啡機、水電裝配、油漆、倉庫資料盤點移送大家動手動脚，像螞蟻搬新家，群策群力，這股數不盡温馨能量和深切的關懷，一直是趨動我們繼續往前的最大原動力。
        br
        br
        | 已成立34年的本會,是前人用歲月累積,辛苦努力所打下的基礎,創業唯艱,守成不易。這一任期,個人秉持以身作則，堅忍前行，有始有终,不達目地絕不放棄的精神，努力為本會發揚光大.但恐力有未逮,無法做到令人滿意,望請指教,更要感謝所有會員及朋友,從旁鼓勵協助，使得會務能順利進行,再次的謝謝大家，感恩不盡，謝謝！
</template>

<script>
import ChairmanBox from "@/components/ChairmanBox.vue";
import chairmanPhoto from "@/assets/images/16-1.jpg";

export default {
  name: "TheHomeChairmantalk",
  components: {
    ChairmanBox,
  },
  data() {
    return {
      chairmanPhoto,
    };
  },
};
</script>

<style module lang="sass">
.talkswrapper
  padding: 30px
</style>
